export default "__VITE_ASSET__D5SuM$vC__"